import axios from 'axios'

import {cookie} from './cookie'
import {getRequestParams} from './getRequestParams'
import {getFullUrl} from './getFullUrl'

const COOKIE_PARAMS = ['visit', 'start_page', 'utm_medium', 'utm_source', 'utm_content', 'utm_keyword', 'user']
const FORM_HANDLER_URL = '/index.php?route=tool/form'

setCookies()

const getFormData = function (form) {
  if (form.length > 0) {
    let source = ''
    if (form.dataset.source) {
      source = form.dataset.source
    }
    const data = new FormData(form)
    data.append('source', source)
    data.append('current_page', location.toString())
    COOKIE_PARAMS.forEach(cookieName => {
      const value = cookie.getCookie('uls_' + cookieName)
      if (value) {
        data.append(cookieName, value)
      }
    })

    if (window.pageName) {
      data.append('page_name', window.pageName)
    }

    return data
  }
  return null
}

export function formHandler({form, onSuccess, mutateData, onValidationError, onFatalError}) {
  form.addEventListener('submit', function (e) {
    e.preventDefault()

    const submitBtn = form.querySelector('button[type="submit"]')
    submitBtn.disabled = true
    submitBtn.textContent = 'Загрузка...'
    submitBtn.style.opacity = 0.5

    const formData = getFormData(this)
    const originalFormDataMap = {}
    for (let row of formData.entries()) {
      if (originalFormDataMap[row[0]] instanceof Array) {
        originalFormDataMap[row[0]].push(row[1])
      } else if (originalFormDataMap[row[0]]) {
        originalFormDataMap[row[0]] = [originalFormDataMap[row[0]], row[1]]
      } else {
        originalFormDataMap[row[0]] = row[1]
      }
    }

    if (mutateData) {
      mutateData(formData)
    }

    if (formData.has('source')) {
      formData.set('source', encodeURI(formData.get('source').toString()))
    }

    form.dispatchEvent(new CustomEvent('ajax-form:submit-start', {bubbles: true}))

    axios
      .post(FORM_HANDLER_URL + '&form_id=' + form.dataset.id, formData)
      .then((r) => {
        const data = r.data

        submitBtn.removeAttribute('disabled')
        submitBtn.textContent = 'Отправить ещё раз'
        submitBtn.style.opacity = 1

        if (data.success) {
          onSuccess(data.success)
          // eslint-disable-next-line no-prototype-builtins
        } else if (Array.isArray(data.error)) {
          onValidationError(data.error)
        } else {
          onFatalError()
        }
      })
      .catch(() => {
        onFatalError()
      })
      .finally(() => {
        form.dispatchEvent(new CustomEvent('ajax-form:submit-end', {bubbles: true}))
      })
  })
}

/* eslint-disable no-prototype-builtins */
function setCookies() {
  const referrer = document.referrer ? (getFullUrl(document.referrer)) : ''

  const options = {
    'expires': new Date(new Date().getTime() + 30 * 3600 * 1000),
    'path:': '/'
  }

  if (!referrer || referrer.host !== location.host) {
    const requestParams = getRequestParams()
    if (cookie.getCookie('uls_visit') === undefined) {
      cookie.setCookie('uls_visit', 0, options)
    } else {
      cookie.setCookie('uls_visit', parseInt(cookie.getCookie('uls_visit')) + 1, options)
    }
    cookie.setCookie('uls_start_page', location.toString(), options)
    if (requestParams.hasOwnProperty('utm_medium')) {
      cookie.setCookie('uls_utm_medium', requestParams['utm_medium'], options)
    }
    if (requestParams.hasOwnProperty('utm_source')) {
      cookie.setCookie('uls_utm_source', requestParams['utm_source'], options)
    }
    if (requestParams.hasOwnProperty('utm_content')) {
      cookie.setCookie('uls_utm_content', requestParams['utm_content'], options)
    }
    if (requestParams.hasOwnProperty('utm_keyword')) {
      cookie.setCookie('uls_utm_keyword', requestParams['utm_keyword'], options)
    }
  }

  if (cookie.getCookie('uls_user') === undefined) {
    cookie.setCookie(
      'uls_user',
      (function () {
        return (Math.floor(Math.random() * Math.pow(10, 6))).toString() + (Date.now() % Math.pow(10, 5)).toString()
      })(),
      options
    )
  }
}
/* eslint-enable */
